import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { FUNNEL_PRICE_DISPLAY_RULE_MODULE, PRICE_DISPLAY_RULE_DEFAULT_COLUMNS } from "../constant/funnelPriceDisplayRuleConstant";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setFunnelPriceDisplayRulePreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: FUNNEL_PRICE_DISPLAY_RULE_MODULE,
        default_columns: PRICE_DISPLAY_RULE_DEFAULT_COLUMNS,
        default_order_by: '-created_date',
    });
